import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { ProductECommerceWidgetComponent } from '../product-ecommerce-widget/product-ecommerce-widget.component';

@Component({
    selector: 'app-formly-product-ecommerce-widget',
    imports: [ProductECommerceWidgetComponent],
    templateUrl: './formly-product-ecommerce-widget.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyProductECommerceWidgetComponent extends FieldType<FieldTypeConfig> {

}
